var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"base-expander",attrs:{"aria-label":_vm.expanderLabel},on:{"click":function($event){_vm.isExpanded = !_vm.isExpanded}}},[_c('div',{class:[
        'base-expander__title',
        { 'base-expander__title--blue': _vm.withValidation }
      ]},[(_vm.withValidation)?_c('div',{staticClass:"validation"},[(_vm.isValid)?_c('valid-img',{staticClass:"validation__indicator"}):_c('invalid-img',{staticClass:"validation__indicator"})],1):_vm._e(),_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_c('chevron-img',{class:[
        'base-expander__chevron',
        {
          expanded: _vm.isExpanded,
          'base-expander__chevron--black': !_vm.withValidation
        }
      ]})],1),_c('div',{staticClass:"filter-content-container",class:{ last: _vm.last }},[_c('div',{staticClass:"filter-content",class:{ hidden: !_vm.isExpanded }},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }